<template>
  <FilterLane
    :items="items"
    :class-add="classAdd"
    @setCurrentItem="setCurrentItem"
  />
</template>

<script>
import FilterLane from '@/components/filter/FilterLane.vue'

export default {
  name: 'LocalFilterLane',
  components: {
    FilterLane
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    classAdd: {
      type: String,
      default: ''
    }
  },
  methods: {
    setCurrentItem(item) {
      this.$emit('setCurrentItem', item)
    }
  }
}
</script>